import { render, staticRenderFns } from "./ParametrizacaoAcaoPasso4ColunaComplementoInformacoes.vue?vue&type=template&id=e262ab2e&"
import script from "./ParametrizacaoAcaoPasso4ColunaComplementoInformacoes.vue?vue&type=script&lang=js&"
export * from "./ParametrizacaoAcaoPasso4ColunaComplementoInformacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAutocomplete,VCol,VRow,VSwitch})
